// extracted by mini-css-extract-plugin
module.exports = {"title":"CarouselNavigation_title__65h7P","navigation":"CarouselNavigation_navigation__8vIhv","controls":"CarouselNavigation_controls__mTIwL"};